@if (limitsExceeded()) {
  <button mat-icon-button (click)="showLimits()">
    @if (withShake) {
      <mat-icon color="accent">warning</mat-icon>
    } @else {
      <mat-icon>warning</mat-icon>
    }
  </button>
}
